import React from 'react'

import * as styles from './index.module.css'

const CareerBoard = ({ nodeLocale }) => {
  return (
    <div id="CareerBoard" className="wrapper">
      <div className={styles.container}>
        <h2 className={`${styles.centered}`}>Current job openings</h2>
      </div>
    </div>
  )
}

export default CareerBoard
